import { BaseDataIcon } from "components/Primitives";
import { escapeParam, INavigationItem } from "domain/navigation/navigation-item";
import { AvailablePomRoutes, AvailableBaseRoutes } from "utils/constants";

export function getPomAdminNavItems(bcEditMasterDataUrl?: string): INavigationItem[] {
  return [
    {
      label: "navigation.basedata.label",
      icon: BaseDataIcon,
      to: "",
      visible: true,
      isParent: true,
      content: [
        {
          label: "navigation.basedata.users.label",
          to: AvailableBaseRoutes.UserList,
          visible: true,
        },
        {
          label: "navigation.basedata.groups.label",
          to: AvailableBaseRoutes.GroupList,
          visible: true,
          invisibleChildrenUrls: [
            AvailablePomRoutes.ManufacturerCreate,
            escapeParam(AvailablePomRoutes.ManufacturerDetail, ":id"),
            escapeParam(AvailablePomRoutes.ManufacturerEdit, ":id"),
          ],
        },
        ...(bcEditMasterDataUrl
          ? [
              {
                label: "navigation.basedata.bcEdit",
                to: "",
                externalUrl: bcEditMasterDataUrl,
                visible: true,
              },
            ]
          : []),
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerCreate,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerDetail,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerEdit,
          visible: false,
        },
      ],
    },
  ];
}

export function getPomMainContactNavItems(erpNumber: string | undefined, bcEditMasterDataUrl?: string): INavigationItem[] {
  return [
    {
      label: "navigation.basedata.label",
      icon: BaseDataIcon,
      to: "/portal/groups",
      visible: true,
      isParent: true,
      content: [
        {
          label: "navigation.basedata.groups.account",
          to: AvailableBaseRoutes.GroupDetail.replace(":erpNumber", erpNumber ?? ""),
          visible: true,
          invisibleChildrenUrls: [
            AvailablePomRoutes.ManufacturerCreate,
            escapeParam(AvailablePomRoutes.ManufacturerDetail, ":id"),
            escapeParam(AvailablePomRoutes.ManufacturerEdit, ":id"),
          ],
        },
        ...(bcEditMasterDataUrl
          ? [
              {
                label: "navigation.basedata.bcEdit",
                to: "",
                externalUrl: bcEditMasterDataUrl,
                visible: true,
              },
            ]
          : []),
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerCreate,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerDetail,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerEdit,
          visible: false,
        },
      ],
    },
  ];
}

export function getPomAgencyNavItems(erpNumber: string | undefined, bcEditMasterDataUrl?: string): INavigationItem[] {
  return [
    {
      label: "navigation.basedata.label",
      icon: BaseDataIcon,
      to: "/portal/pom/groups",
      visible: true,
      isParent: true,
      content: [
        {
          label: "navigation.basedata.groups.label",
          to: AvailableBaseRoutes.GroupDetail.replace(":erpNumber", erpNumber ?? ""),
          visible: true,
          invisibleChildrenUrls: [
            AvailablePomRoutes.ManufacturerCreate,
            escapeParam(AvailablePomRoutes.ManufacturerDetail, ":id"),
            escapeParam(AvailablePomRoutes.ManufacturerEdit, ":id"),
          ],
        },
        ...(bcEditMasterDataUrl
          ? [
              {
                label: "navigation.basedata.bcEdit",
                to: "",
                externalUrl: bcEditMasterDataUrl,
                visible: true,
              },
            ]
          : []),
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerCreate,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerDetail,
          visible: false,
        },
        {
          label: "",
          to: AvailablePomRoutes.ManufacturerEdit,
          visible: false,
        },
      ],
    },
  ];
}
